var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_48_2",
    "data-name": "Component 48 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.235,
    viewBox: "0 0 19.5 19.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M8.161,2.58a1.875,1.875,0,0,1,1.678,0l4.993,2.5a.381.381,0,0,0,.336,0l3.869-1.935A1.875,1.875,0,0,1,21.75,4.82V17.305a1.874,1.874,0,0,1-1.037,1.677l-4.875,2.437a1.875,1.875,0,0,1-1.676,0l-4.994-2.5a.375.375,0,0,0-.336,0L4.964,20.857A1.875,1.875,0,0,1,2.25,19.18V6.7A1.874,1.874,0,0,1,3.286,5.018L8.161,2.581ZM9,6a.75.75,0,0,1,.75.75V15a.75.75,0,0,1-1.5,0V6.75A.75.75,0,0,1,9,6Zm6.75,3a.75.75,0,0,0-1.5,0v8.25a.75.75,0,0,0,1.5,0Z",
    transform: "translate(-2.25 -2.382)",
    fill: "#293139",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.cfaad2be8652563b55f7ee5a18e5c5c3.svg";
export { ForwardRef as ReactComponent };